import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { createStyles, Box } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

const useStyles = createStyles((theme) => {
    return {
        banner: {
            background: theme.colors.blue[1],
            borderBottom: `1px solid ${theme.colors.blue}`,
            color: theme.colors.blue,
            // background: '#ffaf00',
            // borderBottom: '1px solid #f36400',
            // color: '#fff',
            textAlign: 'center',
            zIndex: 150,
            // position: 'relative',
            padding: '0.4rem',
            fontWeight: 500,
            position: 'fixed',
            left: 0,
            right: 0,
            top: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px'
        }
    };
});

export const StagingEnvBanner: React.FC<{}> = (props) => {
    const { classes } = useStyles();
    const { t } = useTranslation('components', { keyPrefix: 'stagingEnvBanner' });

    return (
        <Box className={classes.banner}>
            <IconAlertTriangle />
            {t('content')}
            <IconAlertTriangle />
        </Box>
    );
};
